import React from 'react'
import { Grid, Typography, Paper } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import moment from 'moment-timezone'
import NumberFormat from 'react-number-format'
import { dateFormat } from '../utils/formatter'

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1
  },
  paper: {
    padding: theme.spacing(2),
    color: 'rgba(0,0,0,0.9)',
    height: '100%'
  },
  descript: { fontSize: '0.8rem', color: '#545454' },
  descriptVal: { fontSize: '0.85rem' }
}))

/** Renders empty string for null/undefined and stray string "null"/"undefined" from APIs */
const displayText = (v) => {
  if (v === null || v === undefined) return ''
  if (typeof v === 'string' && (v === 'null' || v === 'undefined')) return ''
  return v
}

const maritalStatus = (status) => {
  switch (status) {
    case 'D': return 'Divorced'
    case 'M': return 'Married'
    case 'S': return 'Single'
    case 'W': return 'Widowed'
    case 'L': return 'Legally Separated'
    case 'O': return 'Significant Other'
    case 'P': return 'Domestic Partner'
    case 'C': return 'Common Law'
    case 'R': return 'Separated'
    case 'U': return 'Unmarried'
  }
}

export default function MainInfo(props) {
  const classes = useStyles()

  props.data['SEX_DESC'] = props.data.SEX === 'M' ? 'Male' : props.data.SEX === 'F' ? 'Female' : ''
  props.data['MARITAL_DESC'] = maritalStatus(props.data.TRUE_MAR_STAT)

  const printValue = (lookup, description, secondary, secondType) => {
    const isDate = description.toLowerCase().indexOf('date') !== -1
    const primary = isDate ? dateFormat(props.data[lookup]) : displayText(props.data[lookup])
    const secondaryVal = secondary ? props.data[secondary] : undefined
    const hasSecondary = secondary && displayText(secondaryVal) !== ''
    const secondaryText = hasSecondary
      ? ` (${secondType === 'date'
        ? dateFormat(secondaryVal)
        : displayText(secondaryVal)
        })`
      : ''
    return (
      <div>
        <span className={classes.descript}>{`${description}:  `}</span>
        <span className={classes.descriptVal}>
          {`${primary}${secondaryText} `}
        </span>
      </div>
    )
  }
  return (
    <div className={classes.root}>
      <Grid
        container
        spacing={1}
        direction='row'
        justifyContent='flex-start'
        alignItems='stretch'
      >
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <Paper elevation={3} className={classes.paper}>
            <Typography variant='h5'>Main Info</Typography>
            <Grid
              container
              spacing={0}
              direction='row'
              justifyContent='space-evenly'
              alignItems='flex-start'
            >
              <Grid item xs={12} sm={6} lg={6}>
                {printValue('FIRST_NAME', 'First Name')}
                {printValue('LAST_NAME', 'Last Name')}
                {printValue('MIDDLE_NAME', 'Middle Name')}
                {printValue('NICK_NAME', 'Preferred Name')}
                {printValue('COMPANY', 'Company')}
                {printValue('FICA_NBR', 'Fica Number')}

                {printValue('EMP_STATUS', 'Status', 'EMP_STATUS_DESC')}
              </Grid>
              <Grid item xs={12} sm={6} lg={6}>
                {printValue('DATE_HIRED', 'Hire Date')}
                {printValue('ADJ_HIRE_DATE', 'Adjusted Hire Date')}
                {printValue('NEW_HIRE_DATE', 'Reported as New Hire Date')}
                {printValue('FST_DAY_WORKED', 'First Date Worked')}
                {printValue('SENIOR_DATE', 'Senior Date')}
                {printValue('ANNIVERS_DATE', 'Anniversary Date')}
                {printValue('LAST_DAY_PAID', 'Last Date Paid')}
                {printValue('TERM_DATE', 'Term Date')}
              </Grid>
            </Grid>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <Paper elevation={3} className={classes.paper}>
            <Typography variant='h5'>Assignment</Typography>
            {printValue('PROCESS_LEVEL', 'Process Level', 'PROCESS_LEVEL_NAME')}
            {printValue('DEPARTMENT', 'Department', 'DEPARTMENT_NAME')}
            {printValue('LOCAT_CODE', 'Location', 'LOCAT_DESC')}
            {printValue('POSITION', 'Position', 'POS_DESC')}
            {printValue('JOB_CODE', 'Job Code', 'JOB_CODE_DESC')}
            {printValue('SUPERVISOR', 'Supervisor Code', 'SUPERVISOR_DESC')}
            {printValue('SUPERVISOR_NAME', 'Supervisor', 'SUPERVISOR_EMPLOYEE')}
            {printValue('BARGAIN_UNIT', 'Bargain Unit', 'BU_DESC')}
            {printValue('UNION_CODE', 'Union Code', 'UNION_DESC')}
          </Paper>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={8}>
          <Paper elevation={3} className={classes.paper}>
            <Typography variant='h5'>Employee Personal</Typography>
            <Grid
              container
              spacing={0}
              direction='row'
              justifyContent='space-evenly'
              alignItems='flex-start'
            >
              <Grid item xs={12} sm={6} md={6} lg={6}>
                {printValue('BIRTHDATE', 'Birth Date')}
                {printValue('BIRTH_CITY', 'Birth City')}
                {printValue('BIRTH_STATE', 'Birth State')}
                {printValue('BIRTH_CNTRY_CD', 'Birth Country Code')}
                {printValue('FORMER_FST_NM', 'Former First Name')}
                {printValue('FORMER_LST_NM', 'Former Last Name')}
                {printValue('MAIDEN_LST_NM', 'Maiden Last Name')}
                {printValue('MAIDEN_FST_NM', 'Maiden First Name')}
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6}>
                {printValue('SEX', 'Sex', 'SEX_DESC')}
                {printValue('VETERAN', 'Veteran')}
                {printValue('DECEASED', 'Deceased', 'DEATH_DATE', 'date')}
                {printValue('EEO_CLASS', 'Ethnicity', 'EEO_DESC')}
                {printValue('DISABILITY', 'Disability', 'DISABILITY_TYPE')}
                {printValue('TRUE_MAR_STAT', 'Marital Status', 'MARITAL_DESC')}
                {printValue('RELIGION', 'Religion')}
              </Grid>
            </Grid>
          </Paper>
        </Grid>

        <Grid item xs={12} sm={6} md={6} lg={4}>


          <Paper elevation={3} className={classes.paper}>
            <Typography variant='h5'>Address</Typography>
            <div className={classes.descriptVal}>{displayText(props.data['ADDR1'])}</div>
            <div className={classes.descriptVal}>{displayText(props.data['ADDR2'])}</div>
            <div className={classes.descriptVal}>{displayText(props.data['ADDR3'])}</div>
            <div className={classes.descriptVal}>{displayText(props.data['ADDR4'])}</div>
            <div
              className={classes.descriptVal}
            >{`${displayText(props.data['CITY'])}, ${displayText(props.data['STATE'])} ${displayText(props.data['ZIP'])}`}</div>
            {printValue('COUNTY', 'County')}
            <br />
            <Typography variant='h5'>Supplemental Address</Typography>
            <div className={classes.descriptVal}>{displayText(props.data['SUPP_ADDR1'])}</div>
            <div className={classes.descriptVal}>{displayText(props.data['SUPP_ADDR2'])}</div>
            <div className={classes.descriptVal}>{displayText(props.data['SUPP_ADDR3'])}</div>
            <div className={classes.descriptVal}>{displayText(props.data['SUPP_ADDR4'])}</div>
            <div
              className={classes.descriptVal}
            >{`${displayText(props.data['SUPP_CITY'])}, ${displayText(props.data['SUPP_STATE'])} ${displayText(props.data['SUPP_ZIP'])}`}</div>

          </Paper>
        </Grid>



        <Grid item xs={12} sm={6} md={6} lg={3}>

          <Paper
            style={{ height: '100%', flexGrow: 1 }}
            elevation={3}
            className={classes.paper}
          >
            <Typography variant='h5'>Contact</Typography>
            {printValue('EMAIL_ADDRESS', 'Email')}
            {printValue('HM_PHONE_CNTRY', 'Home Phone Country')}
            {printValue('HM_PHONE_NBR', 'Home Phone Number')}
            {printValue('WK_PHONE_CNTRY', 'Work Phone Country')}
            {printValue('WK_PHONE_NBR', 'Work Phone Number')}
            {printValue('WK_PHONE_EXT', 'Work Extension')}
          </Paper>

        </Grid>

        <Grid item xs={12} sm={6} md={6} lg={6}>
          <Paper elevation={3} className={classes.paper}>
            <Typography variant='h5'>Pay</Typography>
            <Grid
              container
              spacing={0}
              direction='row'
              justifyContent='flex-start'
              alignItems='flex-start'
            >
              <Grid item md={12} lg={6}>
                {printValue('SALARY_CLASS', 'Salary Class')}
                {printValue('PAY_FREQUENCY', 'Pay Frequency')}
                <div>
                  <span className={classes.descript}>{`Pay Rate:  `}</span>
                  <span className={classes.descriptVal}>
                    <NumberFormat
                      value={props.data['PAY_RATE']}
                      displayType='text'
                      thousandSeparator={true}
                      prefix={'$'}
                    />
                  </span>
                </div>
                {printValue('ANNUAL_HOURS', 'Annual Hours')}
                {printValue('EXEMPT_EMP', 'Exempt from Overtime')}
              </Grid>
              <Grid item md={12} lg={6}>
                {printValue('PAY_STEP', 'Pay Step')}
                {printValue('PAY_GRADE', 'Pay Grade')}
                {printValue('SCHEDULE', 'Schedule')}
                {printValue('OT_PLAN_CODE', 'OT Plan Code')}
                {printValue('NBR_FTE', 'FTE')}
              </Grid>
            </Grid>
          </Paper>
        </Grid>

        <Grid item xs={12} sm={6} md={6} lg={3}>
          <Paper elevation={3} className={classes.paper}>
            <Typography variant='h5'>Work Info</Typography>
            {printValue('HIRE_SOURCE', 'Hire Source')}
            {printValue('I9_STATUS', 'I9 Status', 'I9_DESC')}
            {printValue('WORK_STATE', 'Work State')}
            {printValue('TAX_STATE', 'Tax State')}
            {printValue('SEC_LVL', 'Security Level')}
            {printValue('SEC_LOCATION', 'Security Location')}
            {printValue('COMP_CODE', 'Misc Code')}
            {printValue('COMP_NBR', 'Misc Number')}
          </Paper>
        </Grid>

        <Grid item xs={12}>
          <Paper elevation={3} className={classes.paper}>
            <Typography variant='h5'>Work Eligibility</Typography>
            <Grid
              container
              spacing={1}
              direction='row'
              justifyContent='flex-start'
              alignItems='flex-start'
            >
              <Grid item xs={12} sm={12} md={4}>
                {printValue('I9_ALIEN_NBR', 'I9 Alien Number')}
                {printValue('I9_ADMIT_NBR', 'I9 Admit Number')}
                {printValue('I9_STA_EXP_DT', 'I9 Status Expiration Date')}
                {printValue('I9_AUTHORIZE', 'I9 Authorize')}
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                Document 1{printValue('I9_DOC_TYPE_01', 'I9 Doc Type')}
                {printValue('I9_DOC_DESCR_01', 'Description')}
                {printValue('I9_DOC_NBR_01', 'Number')}
                {printValue('I9_DOC_EXP_DT_01', 'Expiration Date')}
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                Document 2{printValue('I9_DOC_TYPE_02', 'I9 Doc Type')}
                {printValue('I9_DOC_DESCR_02', 'Description')}
                {printValue('I9_DOC_NBR_02', 'Number')}
                {printValue('I9_DOC_EXP_DT_02', 'Expiration Date')}
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
    </div>
  )
}
